var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconOverflowMenuVertical = function SvgIconOverflowMenuVertical(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "none",
    viewBox: "0 0 32 32"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#092B49",
    d: "M16 10a2 2 0 1 0 0-4 2 2 0 0 0 0 4M16 18a2 2 0 1 0 0-4 2 2 0 0 0 0 4M16 26a2 2 0 1 0 0-4 2 2 0 0 0 0 4"
  })));
};
export default SvgIconOverflowMenuVertical;